module.exports = __webpack_public_path__ + "static/img/logo.bk.dcea423.png";